import { Link } from 'react-router-dom'
import { AiFillHome } from 'react-icons/ai'

export default function Header() {

    const onButtonClick = () => {
        fetch('Adam_Paczkowski_Resume.pdf').then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob)

                let alink = document.createElement('a')

                alink.href = fileURL
                alink.download = 'Adam_Paczkowski_Resume.pdf'
                alink.click()
            })
        })
    }

    return (
        <header>
            <nav className='navbar flex justify-center md:justify-end'>
                <Link to="/">
                    <button className='btn btn-primary mx-1 transition ease-in-out hover:scale-110 duration-200'><AiFillHome /></button>
                </Link>
                <Link to="/about">
                    <button className='btn btn-primary mx-2 w-24 transition ease-in-out hover:scale-110 duration-200'>ABOUT</button>
                </Link>
                <Link to="/projects">
                    <button className='btn btn-primary mx-2 w-24 transition ease-in-out hover:scale-110 duration-200'>PROJECTS</button>
                </Link>
                <button className='btn btn-primary mx-1 w-24 transition ease-in-out hover:scale-110 duration-200' onClick={onButtonClick}>RESUME</button>
            </nav>
        </header>
    )
}